<template>
  <div class="recommend-box">
    <div class="recommend-item">
      <div class="item-header">
        <p class="item-title">新手教程</p>
        <div class="to-more" @click="toPlaza('新手教程')">
          <span>更多</span>
          <i class="iconfont icon-Subtract"></i>
        </div>
      </div>
      <div class="course-list">
        <courseItem
          v-for="item in xsjcData"
          :key="item.id"
          :info="item"
          @refresh="getCourseList(1)"
        />
      </div>
    </div>
    <div class="recommend-item">
      <div class="item-header">
        <p class="item-title">功能讲解</p>
        <div class="to-more" @click="toPlaza('功能讲解')">
          <span>更多</span>
          <i class="iconfont icon-Subtract"></i>
        </div>
      </div>
      <div class="course-list">
        <courseItem
          v-for="item in gnjjData"
          :key="item.id"
          :info="item"
          @refresh="getCourseList(2)"
        />
      </div>
    </div>
    <div class="recommend-item">
      <div class="item-header">
        <p class="item-title">运营技巧</p>
        <div class="to-more" @click="toPlaza('运营技巧')">
          <span>更多</span>
          <i class="iconfont icon-Subtract"></i>
        </div>
      </div>
      <div class="course-list">
        <courseItem
          v-for="item in yyjqData"
          :key="item.id"
          :info="item"
          @refresh="getCourseList(3)"
        />
      </div>
    </div>
    <!-- <div class="recommend-item">
      <div class="item-header">
        <p class="item-title">教研提升</p>
        <div class="to-more" @click="toPlaza('教研提升')">
          <span>更多</span>
          <i class="iconfont icon-Subtract"></i>
        </div>
      </div>
      <div class="course-list">
        <courseItem
          v-for="item in jytsData"
          :key="item.id"
          :info="item"
          @refresh="getCourseList(4)"
        />
      </div>
    </div> -->
  </div>
</template>

<script>
import api from "../../assets/js/api";
import courseItem from "./course-item.vue";
export default {
  name: "ShopCenterAdminWebRecommendCourse",
  components: {
    courseItem,
  },
  data() {
    return {
      xsjcIds: [12, 18, 19, 22, 24],
      xsjcData: [],
      gnjjIds: [9, 11, 10, 7, 8],
      gnjjData: [],
      yyjqIds: [13, 14, 15, 32, 34],
      yyjqData: [],
      // jytsIds: [1, 2, 3],
      // jytsData: [],
    };
  },

  mounted() {
    this.getAllList();
  },

  methods: {
    getAllList() {
      this.getCourseList(1);
      this.getCourseList(2);
      this.getCourseList(3);
      // this.getCourseList(4);
    },
    async getCourseList(type) {
      const ids = [];
      switch (type) {
        case 1:
          ids.push(...this.xsjcIds);
          break;
        case 2:
          ids.push(...this.gnjjIds);
          break;
        case 3:
          ids.push(...this.yyjqIds);
          break;
        case 4:
          ids.push(...this.jytsIds);
          break;
        default:
          break;
      }
      const res = await this.$axios.post(api.creatCollege.getCourseList, {
        lessonIds: ids,
        pageIndex: 1,
        pageSize: 5,
      });
      if (res.valid) {
        switch (type) {
          case 1:
            this.xsjcData = res.result.list;
            break;
          case 2:
            this.gnjjData = res.result.list;
            break;
          case 3:
            this.yyjqData = res.result.list;
            break;
          case 4:
            this.jytsData = res.result.list;
            break;
          default:
            break;
        }
      }
    },
    toPlaza(name) {
      this.$emit("to-plaza", name);
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend-box {
  min-width: 1080px;
  padding: 40px;
  border-radius: 5px;
  background: #fff;
  .recommend-item {
    margin-bottom: 40px;
    &:last-child {
      margin-bottom: 0;
    }
    .item-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .item-title {
        color: #3a3d4b;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
      }
      .to-more {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        cursor: pointer;
        &:hover {
          & > span,
          & > i {
            color: #6384f7;
          }
        }
        & > span {
          margin-right: 5px;
          color: #8895a9;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 14px;
        }
        & > i {
          color: #8895a9;
          opacity: 0.6;
        }
      }
    }
    .course-list {
      // display: flex;
      // align-items: center;
      // justify-content: flex-start;
      display: grid;
      grid-template-columns: repeat(5, 18.2%);
      grid-template-rows: 240px;
      column-gap: 2%;
      row-gap: 20px;
      grid-auto-rows: 240px;
    }
  }
}
</style>
